import React, { Component } from "react";
import wireless1 from "../../../semantic/dist/themes/fibrestream/assets/images/wireless1.png";
import wireless2 from "../../../semantic/dist/themes/fibrestream/assets/images/tp_link_archer_23.png";
import router from "../../../semantic/dist/themes/fibrestream/assets/images/router.png";
import { Tab, MenuItem } from "semantic-ui-react";

class WifiOptions extends Component {

  render() {

    const panes = [
      {
        menuItem: <MenuItem key="1" name="Free Wifi Included" className="mr-8" />,
        render: () => (
          <Tab.Pane key="1" attached={false} inverted={true} className="centered grid pt-6">
            <div className="ui grid stackable mx-0 wireless__stack">
              <div className="ui eight wide column vertical center aligned px-0 wireless__block">
                <div className="drop-radial">
                  <img
                    className="ui centered image wireless-image-1"
                    src={wireless1}
                    alt="Router"
                    width="362"
                    height="293"
                  />
                </div>
                <div className="display-3 itc-mdbold">C20</div>
                <h3 className="itc-mdbold wl-title">TP LINK ARCHER</h3>
                <p >Free with Fibre100 ($50 value)</p>
                <h3 className="text-prime itc-mdbold mt-0 wl-price">Promo</h3>
              </div>
              <div className="ui sixteen wide mobile eight wide tablet eight wide computer column vertical center aligned px-0">
                <div className="drop-radial">
                  <img
                    className="ui centered image wireless-image-2"
                    src={wireless2}
                    alt="Router"
                    width="362"
                    height="293"
                  />
                </div>
                <div className="display-3 itc-mdbold">AX23</div>
                <h3 className="itc-mdbold wl-title">TP LINK ARCHER</h3>
                <p>Free with Fibre750 ($100 value)</p>
                <h3 className="text-prime itc-mdbold mt-0 wl-price">Promo</h3>
              </div>
            </div>
          </Tab.Pane>
        )
      },
      {
        menuItem: <MenuItem key="2" name=" Use Your Own" className="ml-8"/>,
        render: () => (          
          <Tab.Pane attached={false} inverted={true} className="centered grid pt-6 use-your-own">
            <div className="ui sixteen wide computer column vertical centered px-0">
              <div className="drop-radial">
                <img className="ui centered image mw-240"
                  src={router} 
                  alt="Router"
                  width="362"
                  height="293" />
              </div>
              <div className="ui centered grid w-400 mx-auto">
                <h3 className="itc-mdbold my-3 text-uc wl-title">Already Have a Router</h3>
                <p>
                All stand-alone wireless routers are compatible. Popular brands include Linksys, D-Link, TP-Link, Securifi and more.
                </p>
              </div>
            </div>
          </Tab.Pane>
        )
      }
    ];

    return (
      <section className="ui inverted vertical segment center aligned wireless">
        <div className="ui container">
          <h3 className="title text-white desktop-only">wireless</h3>
          <div className="display-1 xs">Wi-Fi Options</div>
          <Tab
            panes={panes}
            menu={{ text: true, className: "centered grid my-0" }}
            style={{ background: '#111111'}}
          />
        </div>
      </section>
    );  
  }
}


export default WifiOptions;



// WEBPACK FOOTER //
// ./src/components/home/wifi-options/WifiOptions.js